import { render } from "./AttendeeStatusComponent.vue?vue&type=template&id=2da65b04"
import script from "./AttendeeStatusComponent.vue?vue&type=script&lang=js"
export * from "./AttendeeStatusComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__